import React from 'react';
import LinenImage from '../resorcesfiles/ideak/linen1.jpg'; 
import './SolutionLinen.css';
import Mainmastet from '../masterpage/Mainmastet';


const SolutionLinen = () => {
  return (
    <Mainmastet content={<>  
    <div style={{height:10}}></div>
    <div className="solution-linen">
      <h1>RFID Automation & Tracking for Laundry & Housekeeping</h1>
      <p>
        The linen management solution allows you to automate the issue, return, and administration of pool
        laundry, linen, workwear, and uniforms. It provides visibility throughout the entire textile/laundry cycle
        including centralised as well as decentralised issue and return of clothing, dispatch of used clothing to
        the laundry, and delivery of cleaned and repaired clothing.
      </p>
      <p>
        Individually planned room solutions work like a walk-in wardrobe. When entering and leaving the stock
        room, employees’ clothing is automatically identified and recorded as they pass through the revolving
        doors.
      </p>
      <p>
        Intelligent compartment systems facilitate the decentralised issue and return of textiles/linens/laundry,
        vastly reducing the time spent by employees in the stock room.
      </p>
      <img src={LinenImage} alt="RFID Laundry Tags in Hotels" className="responsive-image" />
    </div>
    
    
    </>} />
  );
};

export default SolutionLinen;
